import { Flex, Spacing, Text } from '@billy/design-system'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { EInvoicingSettings } from '@features/eInvoicingSettings'

export const EInvoicingSettingsForm = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column" gap={Spacing.S24}>
      <Text variant="h2">{t('invoicing_settings.e_invoicing')}</Text>
      <EInvoicingSettings context="Organization" />
    </Flex>
  )
}
